import React from 'react';

export function PlayIcon({ onClick, className }: { onClick?: ()=> void, className?: string }) {
	return (
		<svg onClick={onClick} className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="#149EF2">
			<path d="M15 7.26798C16.3333 8.03778 16.3333 9.96229 15 10.7321L3 17.6603C1.66667 18.4301 -6.72981e-08 17.4678 0 15.9282L6.05683e-07 2.07183C6.72981e-07 0.53223 1.66667 -0.43002 3 0.339781L15 7.26798Z" />
		</svg>
	);
}
